// extracted by mini-css-extract-plugin
export default {"vacancy_list":"style_vacancy_list__4bh6L"};